import React from 'react';
import { FooterAssistance } from '@europrocurement/flexy-components';
import { useUserContactCard } from '@europrocurement/l2d-modules/modules/Utilisateur';
import { useOfferContext } from '@europrocurement/l2d-modules';

const FooterAssistanceConnected: React.FunctionComponent = function () {
    const { callUserContactCardModal } = useUserContactCard();
    const { getTiersCurrentOffer } = useOfferContext();

    return (
        <FooterAssistance
            onContactRequest={callUserContactCardModal}
            onFetchOffer={getTiersCurrentOffer}
        />
    );
};

export default FooterAssistanceConnected;
